class KCVS.Views.ReportDocumentGroupFormView extends Backbone.View
  events:
    "select2:select select" : "sortChoices"

  sortChoices: (e) ->
    $this = $(e.currentTarget)
    $element = $(e.params.data.element)
    $element.detach()
    $this.append($element)
    $this.trigger("change")
